import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import * as functionalUsage from '../../functional-usage'
import type { Plugin } from '../plugin'

/**
 * Reloads the current record's functional usage once a bulk update has been
 * applied.
 *
 * Functional usage is loaded per record, so returning to a record that was
 * already visited does not change its context, and it would otherwise keep
 * showing what was cached before the bulk update.
 */
export const reloadCurrentRecordOnSubmitSuccess = store.effects.create(
  (feature: Plugin['feature'], plugin: Plugin) =>
    feature.actions.submit.success.observe().pipe(
      rxjs.map(action =>
        plugin.collection.plugins
          .lookup(functionalUsage.Plugin)
          .get()
          .feature.actions.loadForCurrentEntity.request.from(action)
          .create(),
      ),
    ),
)
